<div [ngSwitch]="type">
  <av-icon *ngSwitchCase="'info'" name="info" size="sm"></av-icon>
  <av-icon *ngSwitchCase="'danger'" name="close-round" size="sm"></av-icon>
  <av-icon *ngSwitchCase="'warning'" name="alert" size="sm"></av-icon>
  <av-icon *ngSwitchCase="'success'" name="tick-round" size="sm"></av-icon>
</div>
<ng-content></ng-content>
